import { api } from "./client";

export type BackupStatus = "PENDING" | "RUNNING" | "SUCCESS" | "FAILED" | "PARTIAL";

export interface BackupEntry {
  id: string;
  jobId: string;
  railwayProjectName: string;
  railwayServiceName: string;
  databaseUrlMasked: string;
  b2Key: string | null;
  sizeBytes: string | null;
  status: BackupStatus;
  error: string | null;
  createdAt: string;
}

export interface BackupJob {
  id: string;
  status: BackupStatus;
  triggeredBy: string;
  startedAt: string;
  completedAt: string | null;
  error: string | null;
  entries: BackupEntry[];
}

export interface BackupJobList {
  total: number;
  page: number;
  limit: number;
  jobs: BackupJob[];
}

export const backupsApi = {
  trigger: () =>
    api.post<{ jobId: string }>("/backups/trigger").then((r) => r.data),

  list: (page = 1, limit = 20) =>
    api.get<BackupJobList>("/backups", { params: { page, limit } }).then((r) => r.data),

  get: (jobId: string) =>
    api.get<BackupJob>(`/backups/${jobId}`).then((r) => r.data),
};
